<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4>{{ $t('availabilityIntervals.add') }}</h4>
      <CButton color="secondary" @click="goBack">{{ $t('goBack') }}</CButton>
    </div>
    
    <AvailabilityIntervalsForm 
      @submit-requested="onSubmitRequested" 
      :loading="loading">
    </AvailabilityIntervalsForm>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AvailabilityIntervalsForm from './AvailabilityIntervalsForm.vue';
import router from '@/router';

export default {
  components: { AvailabilityIntervalsForm },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState('availabilityIntervals', ['createAvailabilityIntervalOutput', 'generateSlotsOutput'])
  },
  methods: {
    ...mapActions('availabilityIntervals', ['create', 'generateSlots']),
    async onSubmitRequested(interval) {
      this.loading = true;
      try {
        // Reset generateSlotsOutput before starting
        this.$store.commit('availabilityIntervals/setGenerateSlotsOutput', null);
        
        const result = await this.create(interval);
        // After successful creation, automatically generate slots
        // The API returns the created interval object with id
        if (result && result.id) {
          await this.generateSlots({ id: result.id, regenerateExisting: false });
        } else {
          // If we can't get the id, set loading to false
          this.loading = false;
        }
      } catch (error) {
        console.error('Error creating interval:', error);
        this.loading = false;
      }
    },
    goBack() {
      router.push({ name: 'AvailabilityIntervalsList' });
    }
  },
  watch: {
    createAvailabilityIntervalOutput(val) {
      if (val) {
        // Don't set loading to false here, wait for generateSlotsOutput
      }
    },
    generateSlotsOutput(val) {
      if (val) {
        this.loading = false;
        // The form component will handle showing the message via its own watcher
      }
    }
  }
};
</script>

